import React from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../components/Internal-nav';  
import CabinetData from '../data/cabinetdata.json';
import './cabinet-detail.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';

function UpdateFeaturedImage(image) {
    const lgImage = document.getElementById("product-image");
    lgImage.src = image;
}

function CabinetDetail() {
    const { slug } = useParams();
    var val = slug;
    var cabinet = CabinetData.Cabinets.filter(function(item) {
        return item.url === val;
    });

    const cabinetData = cabinet[0];
    const fullDescription = `${cabinetData.productName} - ${cabinetData.standardFeatures?.map(f => f.feature).join('. ')}`;
    const keywords = `kitchen cabinets, bathroom cabinets, ${cabinetData.productName}, ${cabinetData.colors?.map(c => c.colorName).join(', ')}`;

    return (
        <div className='App'>
            <SEO 
                title={cabinetData.productName}
                description={fullDescription}
                keywords={keywords}
                canonicalUrl={`https://bcsurfacesupply.com/cabinets/${slug}`}
                ogImage={cabinetData.imageurl}
            />
            <StructuredData 
                productData={{
                    name: cabinetData.productName,
                    description: fullDescription,
                    image: cabinetData.imageurl,
                    brand: cabinetData.brand,
                    price: cabinetData.price,
                    inStock: true,
                    manufacturer: cabinetData.manufacturer
                }}
                productType="Kitchen Cabinet"
            />
            <header>
                <Navbar />
            </header>

            <div className='cabinet-detail'>
                <div className='detail-left'>
                    <img id="product-image" className='large-product' src={cabinetData.imageurl} alt={cabinetData.altText} />
                    <div className='finish-options'>
                        <h3>More Finish Options</h3>
                        <div className='colors'>
                            {cabinetData.colors ? 
                                cabinetData.colors.map((d,i) => {
                                    if (d.encodedColor.length > 0) {
                                        return <div key={i} style={{backgroundColor: `${d.encodedColor}` }} className="color-name" onClick={() => UpdateFeaturedImage(d.thumbnail)}>
                                            <div>{d.colorName}</div>
                                        </div>
                                    } else {
                                        return <div key={i} style={{backgroundImage: `url(${d.colorimg})` }} className="color-name" onClick={() => UpdateFeaturedImage(d.thumbnail)}>
                                            <div>{d.colorName}</div>
                                        </div>
                                    }
                                })
                                : 'loading'}
                        </div>
                    </div>
                    <div className='quote-request'>
                        <h3>Call Today to Get a Quote</h3>
                        <a href="tel:2603213092" className='quote-button'>
                            <FontAwesomeIcon icon={faMobileAlt} /> (260) 321-3092
                        </a>
                    </div>
                </div>

                <div className='detail-right'>
                    <h2>{cabinetData.productName}</h2>
                    <div className='feature-section'>
                        <h3>Additional Features</h3>
                        <ul className='features'>
                            {cabinetData.additionalFeatures ? 
                                cabinetData.additionalFeatures.map((d,i) => (
                                    <li key={i}>{d.feature}</li>
                                ))
                                : 'loading'}
                        </ul>
                    </div>
                    <div className='feature-section'>
                        <h3>Standard Features</h3>
                        <ul className='features'>
                            {cabinetData.standardFeatures ? 
                                cabinetData.standardFeatures.map((d,i) => (
                                    <li key={i}>{d.feature}</li>
                                ))
                                : 'loading'}
                        </ul>
                    </div>
                    <div className='disclaimer'>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CabinetDetail;